import {EstabelecimentoModel} from '../../estabelecimento.model';
import {Util} from '../../../../utils/util';

export class RascIdentificacaoComplementarModel {
    codigoDistritoSanitario: string;
    codigoRegionalSaude: string;
    // mapeamentoIndigena: MapeamentoIndigenaObj;
    mapeamentoIndigena: any;

    constructor(estabelecimento: EstabelecimentoModel) {
        const complementar = estabelecimento.identificacao.complementar;
        this.codigoDistritoSanitario = complementar ? estabelecimento.identificacao.complementar.idDistritoSanitario : '';
        this.codigoRegionalSaude = complementar ? estabelecimento.identificacao.complementar.idRegionalSaude : '';
        this.mapeamentoIndigena = {
            codigoAldeia: complementar ? estabelecimento.identificacao.complementar.idAldeia : '',
            codigoDsei: complementar ? estabelecimento.identificacao.complementar.idDsei : '',
            codigoPoloBase: complementar ? estabelecimento.identificacao.complementar.idPoloBase : ''
        };
    }
}

export interface MapeamentoIndigenaObj {
    codigoAldeia: string;
    codigoDsei: string;
    codigoPoloBase: string;
}
